import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Convertit un pathname en slug CSS stable.
 * Les segments numériques (IDs dynamiques) sont remplacés par `:id`.
 *
 * Exemples :
 *   /dashboard              → "dashboard"
 *   /procedures/42          → "procedures-:id"
 *   /procedures/42/edit     → "procedures-:id-edit"
 *   /procedures/42/reports/7/edit → "procedures-:id-reports-:id-edit"
 *   /settings/account       → "settings-account"
 *   /                       → "welcome"
 */
function pathnameToPageSlug(pathname) {
    const trimmed = pathname.replace(/^\//, '').replace(/\/+$/, '');
    if (!trimmed) return 'welcome';
    return trimmed
        .split('/')
        .map((segment) => (/^\d+$/.test(segment) ? ':id' : segment))
        .join('-');
}

/**
 * Met à jour `document.body.dataset.page` à chaque changement de route.
 * Permet de cibler une page spécifique en CSS :
 *
 *   [data-page="dashboard"] .my-element { ... }
 *   [data-page^="procedures"] .my-element { ... }
 *
 * Le premier rendu est géré par un script inline dans app.blade.php
 * pour éviter tout flash (FOUC).
 */
export function usePageAttribute() {
    const { pathname } = useLocation();

    useEffect(() => {
        document.body.setAttribute('data-page', pathnameToPageSlug(pathname));
    }, [pathname]);
}
